import React, { useState, useEffect, useRef} from "react";
import parse from 'html-react-parser';
import "../../assets/dataTable.css";
import DataTable from 'react-data-table-component';
import { Link } from 'react-router-dom';

import { api_crud_route, api_list_route, endpoints } from './Config';

import { reqGET, reqDELETE } from '../../Utils';

import { getTokenInfo } from './../../UseToken';
//import UseSidebar from './../../UseSidebar';

import Loader from '../Loader/Loader';
import Swal from 'sweetalert2'

//import Hosts from '../../Hosts';

    // Gilberto added »
/*import {
	set_language,
	content_language, 

} from '../../Utils';*/

import { language } from '../WEBContent/Language';
    // « Gilberto added


    export default function List() {

        const [data, setData] = useState([])
        //const [data_2, setData_2] = useState([])
        const data2 = useRef([]);
        const [/*refresh*/, setRefresh] = useState(0);
        const [isloading, setLoading] = useState(true)
    
        const [lang, set_lang] = useState('pt');
    
        const [permissions, /*set_permissions*/] = useState({})
    
        useEffect(() => {

            let fetchApi = async () => {
                set_lang(localStorage.getItem('lang'))
        
                data2.current = []
                setData([]);
        
                return await reqGET(`${api_list_route(getTokenInfo().companycode)}`)
                    .then(res => {
        
                       /*if('trainer_user' === getTokenInfo().profile) {
                            
                            res.data.forEach(v2 => {
                                 v2.info.trainers.forEach(v3 =>{
                                     if((v3.id === getTokenInfo().id)){
                                        data2.current.push(v2)
                                        setData([...data2.current]); 
                                        setRefresh(refresh + 1)
                                        //setRefresh(r => r + 1)
         
                                     }
                                 }) 
                            })
                        }*/

                        res.data.forEach(v2 => {

                            let date_today = new Date().toJSON().split('T')[0];

                            if(v2.info.date.publication !== '' && v2.info.date.registration_deadline !== '' && date_today <= v2.info.date.registration_deadline) {
                                data2.current.push(v2)
                                setData([...data2.current]);
                                setRefresh(r => r + 1)

                            }
                       })
                        

                        //setData(res.data)
    
                        setLoading(false)
                    })
                    .catch(() => 404
                        //  TODO: ENVIAR PÁGINA 404
                        //alert(error)); 
                    )
            }            
            fetchApi()
        }, []);


        //APAGAR REGISTO
        function apagar(id) {    
            Swal.fire({
                title: language[lang].delete_title,
                text: language[lang].delete_text,
                icon: 'question',
                showCancelButton: true,
                confirmButtonColor: '#0095e8',
                cancelButtonColor: '#d9214e',
                confirmButtonText: language[lang].delete_confirm,
                cancelButtonText: language[lang].delete_cancel
            })
            .then((result) => {
                if (result.isConfirmed) {
                    reqDELETE(api_crud_route, { id: id })
                        .then(res => {
                            //props.history.push(endpoints.list);
                        })
                        .catch(error => console.log(error))
                }
            })
    
        }
    
        const columns = [
            {
                name: language[lang].name,
                selector: 'info.name',
                cell: row => <div>{row.info.name}</div>,
                width: '50%',
                minWidth: '30% !important',
                sortable: true,
                left: true,
            },
            {
                name: language[lang].table_date,
                selector: 'info.date.creation',
                cell: row => {
                    let date = new Date(row.info.date.creation); 
                    
                    return date.getDate().toString().padStart(2, '0') + '/' + (date.getMonth() + 1).toString().padStart(2, '0') + '/' + date.getFullYear()
                },
                width: '10%',
                minWidth: '110px !important',
                sortable: true,
                center: true,
            },
            {
                name: language[lang].table_state,
                selector: 'title',
                cell: row => {
                    let hoje = new Date();
                    //let date = new Date(row.info.date.creation); 
                    
                    let status = 0
                    if(row.info.date.published !== undefined && row.info.date.published !== '') {
                        var date_p = new Date(row.info.date.published);
    
                        status = 1
                        if(hoje >= date_p) 
                            status = 2
                    }
                    if(row.info.date.avaiable !== undefined && row.info.date.avaiable !== '') {
                        var date_a = new Date(row.info.date.avaiable);
    
                        if(hoje > date_a) 
                            status = 3
                    }
                    
                    return (
                        <span className={status === 2 ? "badge rounded-pill fw-normal bg-success" : (status === 1 ? "badge rounded-pill fw-normal bg-info" : "badge rounded-pill fw-normal bg-primary")}>
                            {status === 2 ? language[lang].state_ended : (status === 1 ? language[lang].state_open : language[lang].state_open)}
                        </span>
                    )
                },
                width: '10%',
                minWidth: '82px !important',
                sortable: false,
                center: true,
            },
            {
                name: '',
                right: true,
                export: false,
                print: false,
                width: '20%',
                minWidth: '100px !important',
                cell: row =>
                    <span>
                        <Link className="button button-update button-view d-none" to={{ pathname: endpoints.view, state: { item: row, operation: 'view' } }} replace>
                            <i className="bi bi-eye"></i>
                        </Link>
    
                        {
                        permissions.edit ?
                            <Link className={permissions.edit ? "button button-update" : "d-none" } to={{ pathname: endpoints.regist, state: { item: row, operation: 'edit' } }} style={{ display: '' }} replace>
                                <i className="bi bi-pencil"></i>
                            </Link>
                        :
                            null
                        }
    
                        {
                        permissions.remove ?
                            <button className={permissions.remove ? "button button-delete d-none" : "d-none" } onClick={() => apagar(row['id'])}>
                                <i className="bi bi-trash"></i>
                            </button>
                        :
                            null
                        }
                    </span>
            },
        ];
    
        const defaultComponentOptions = {
            rowsPerPageText: language[lang].table_rows_per_page,
            rangeSeparatorText: language[lang].table_separator,
            noRowsPerPage: false,
            selectAllRowsItem: false,
            selectAllRowsItemText: language[lang].table_all,
        };
    
        return (isloading ?
            
            <Loader />
    
            :
    
            <main>
                <div className={`dash-cards header`}>
                    <h2 className="dash-title">{language[lang].courses_list}</h2>
                    <p>{language[lang].courses_available} / {language[lang].courses_list}</p>
                </div>
                    
                <div id="notes">
                    <div className="container">

                        <div className="mb-5">
                            <div className="">
                            
                                <div className="pb-5">
                                    <div className="div-table">
                                        <div className="table-header text-end my-5 d-none">
                                            <Link className="btn btn-sm btn-secondary rounded-0 multi-item" to={{ pathname: endpoints.regist }}  >
                                                <span>{language[lang].add_new}</span>
                                            </Link>
                                        </div>

                                        <div className="row mt-5">
                                            {
                                            data.map((element) => {
                                                
                                                /*var hoje = new Date();
                                                var date = new Date(element.info.date.creation); 
                                                
                                                let status = 0
                                                if(element.info.date.published !== undefined && element.info.date.published !== '') {
                                                    var date_p = new Date(element.info.date.published);

                                                    status = 1
                                                    if(hoje >= date_p) 
                                                        status = 2
                                                }*/
                                              
                                                return(
                                                    element.content.map((v, key2) => {

                                                        let courseRegistered = false

                                                        let courseRegisteredWaiting = false
                                                        
                                                        if(v.candidates !== undefined && v.candidates.length > 0){
                                                            v.candidates.forEach(v2 => {

                                                                if(v2.trainee_id === getTokenInfo().id && v2.trainee_status === 'accepted'){
                                                                    courseRegistered = true
                                                                }

                                                                if(v2.trainee_id === getTokenInfo().id && v2.trainee_status === 'under_review'){
                                                                    courseRegisteredWaiting = true
                                                                }

                                                            })
                                                        }

                                                        //let strippedText = v.text.replace(/(<([^>]+)>)/gi, "");
                                                       // console.log(strippedText)

                                                        return(
                                                        
                                                            <div className="col-12 col-md-6 col-lg-4 mt-4" key={key2}>
                                                                <div className="card">
                                                                    <div className="card-body">
                                                                        <div className="mb-3">
                                                                            <h5 className="card-title">{v.title}</h5>
                                                                        </div>

                                                                        {
									                                        element.info.date.begin !== undefined && element.info.date.begin !== ''?
                                                                                <p><b>{language[lang].start_date}: </b>{element.info.date.begin.split('T')[0]}</p>
                                                                            :
                                                                                null
                                                                        }
                                                                        
                                                                        {
									                                        element.info.date.registration_begin !== undefined && element.info.date.registration_begin !== '' && 0 ?
                                                                                <p><b>{language[lang].date_registration_begin}: </b>{element.info.date.registration_begin.split('T')[0]}</p>
                                                                            :
                                                                                null
                                                                        }

                                                                        {
									                                        element.info.date.registration_deadline !== undefined && element.info.date.registration_deadline !== ''?
                                                                                <p><b>{language[lang].date_registration_deadline}: </b>{element.info.date.registration_deadline.split('T')[0]}</p>
                                                                            :
                                                                                null
                                                                        }

                                                                        <div className="mt-3">
                                                                            <span className="card-text webkit-line-clamp-5">
                                                                                {parse(v.text)}
                                                                                {/*<p>{parse(strippedText)}</p>*/}
                                                                            </span>
                                                                        </div>

                                                                        <div className="float-right mt-3">
                                                                            {
                                                                                courseRegistered ? 
                                                                                    <span className="badge bg-success me-2 py-2 rounded-pill">{language[lang].formation_registered}</span>
                                                                                : 
                                                                                courseRegisteredWaiting ? 
                                                                                    <span className="badge bg-warning me-2 py-2 rounded-pill">{language[lang].formation_registration_waiting}</span>
                                                                                : null
                                                                            }
                                                                            <Link className="button button-update button-view" alt={language[lang].see_details} title={language[lang].see_details} to={{ pathname: endpoints.view, state: { item: element, operation: 'view' } }} replace>
                                                                                <i className="bi bi-eye red"></i>
                                                                            </Link>
                                                                        </div>

                                                                    </div>
                                                                </div>  
                                                            </div>
                                                        )
                                                    })
                                                )
                                            }) 
                                            }	
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
    
                        <div className="card mb-5 mb-xl-8 d-none">
                            <div className="card-body">
                                <div className="pb-10 ">
                                    <div className="div-table">
                                    <div className="table-header text-end mb-5">
                                            <Link className="btn btn-sm btn-secondary rounded-0 multi-item" to={{ pathname: endpoints.regist }}  >
                                                <span>{language[lang].add_new}</span>
                                            </Link>
                                        </div>
                                        <div className="table-body">
    
                                            <DataTable
                                                columns={columns}
                                                data={data}
                                                noDataComponent={language[lang].table_empty}
                                                noHeader
                                                pagination
                                                exportHeaders
                                                paginationComponentOptions={defaultComponentOptions}
                                                paginationPerPage={25}
                                                paginationRowsPerPageOptions={[25, 50, 100]}
                                            />
                                            
                                        </div>
                                    </div>
                                </div>
    
                            </div>
                        </div>
    
                    </div>
                </div>
            </main>
        )
    }